/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2018 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

:local(.root)
  &.hide-buttons
    :global(.spectrum-Dialog-footer)
      visibility hidden

:local(.steps)
  padding-top 0
  padding-right 0
  right -2px
  :global(.spectrum-Steplist-item)
      padding-right 2px
      width 24px
    :global(.spectrum-Steplist-label)
      display none
    :global(.spectrum-Steplist-markerContainer)
      margin-left 0
      width 10px
    :global(.spectrum-Steplist-segment)
      right 14px
      width 14px
  :global(.spectrum-Steplist-item):first-child
    width 12px
  :global(.spectrum-Steplist-item):last-child
      :global(.spectrum-Steplist-markerContainer)
        left 50%
        margin 0
      :global(.spectrum-Steplist-segment)
        right 14px
